import { useCallback } from 'react'

import { useCanTrack, useRegion } from '@cash-web/shared-ui-region-provider'
import { logEvent as logCdfEvent } from '@cash-web/shared-util-cdf-analytics'
import type { Event as CdfEvent } from '@squareup/customer-data-events-web'

export function useLogCashWebCdfEvent({
  hostName,
  customerToken,
}: {
  hostName?: string
  customerToken?: string
} = {}): (data: CdfEvent) => Promise<void> {
  const canTrackRegion = useCanTrack()
  const region = useRegion()

  return useCallback(
    async (event: CdfEvent) => {
      if (canTrackRegion) {
        await logCdfEvent({ event, region, hostName, customerToken })
      }
    },
    [canTrackRegion, hostName, region, customerToken]
  )
}
